import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiMail } from "react-icons/fi";
import styles from "../style/cta.module.css";

const CONTACT_PATH = "/contact";

const CTA_VARIANTS = {
  contact: {
    title: "Let's work together",
    lead: "Use the form above to discuss a product, a collaboration, or an idea.",
    supportText: "From research to reality.",
    showButton: false,
  },
  default: {
    title: "Ready to start?",
    lead: "Have a project or a new direction in mind? Let’s connect and figure out how to build it. I'm always open to new challenges and opportunities.",
    buttonTo: "/contact",
    buttonLabel: "Get in Touch",
    showButton: true,
  },
};

const CTASection = () => {
  const { pathname } = useLocation();
  const content =
    pathname === CONTACT_PATH ? CTA_VARIANTS.contact : CTA_VARIANTS.default;

  return (
    <div className={`container-fluid pt-3 pt-md-4 ${styles.ctaSection}`}>
      <div className="container page-shell">
        <div className="row d-flex justify-content-between align-items-center gx-4 gy-2 gy-md-4">
          <div className="col-lg-6 col-md-7 col-12">
            <p className={`${styles.ctaTitle} m-0 p-0 pb-2`}>{content.title}</p>
            <p className={`text-light ${styles.ctaLeadText}`}>{content.lead}</p>
          </div>

          <div className="col-lg-4 col-md-5 col-12 text-start text-md-end cta-actions">
            {content.showButton ? (
              <>
                <Link
                  to={content.buttonTo}
                  className={`${styles.ctaButton} w-sm-100 mb-3 d-inline-flex align-items-center justify-content-center gap-2 ${styles.ctaPrimaryLink}`}
                >
                  <FiMail aria-hidden="true" />
                  {content.buttonLabel}
                </Link>
                <p className="text-light mb-0 cta-support-text">
                  {content.supportText}
                </p>
              </>
            ) : (
              <p className="text-light mt-0 mt-md-5 cta-support-text">
                {content.supportText}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTASection;
